import React, {useState} from 'react';
import Select from "react-select";
import Switch from "react-switch";
import {FaEyeSlash, FaEye} from "react-icons/fa";

const OpsInput = ({
                      disabled = false,
                      error = false,
                      required = false,
                      customType = "normal",
                      togglePasswordVisiblity,
                      passwordShown = false,
                      type = "text",
                      name = "",
                      accept,
                      id = "",
                      placeholder = "",
                      maxLength = 600,
                      label = "",
                      labelColor = "color-1",
                      labelWeight = 400,
                      componentClassName = "",
                      className,
                      onChange,
                      value,
                      size = "md",

                      isClearable,
                      isSearchable,
                      options,

                      uncheckedIcon = false,
                      checkedIcon = false,
                      boxShadow = "0px 1px 5px rgba(0, 0, 0, 0.6)",
                      activeBoxShadow = "0px 0px 1px 10px rgba(0, 0, 0, 0.2)",
                      height = 20,
                      width = 40,
                      checked,
                      offColor = "#FF0000",
                      onColor = "#00D83C",
                      autoFocus
                  }) => {

    const [showPassword, setShowPassword] = useState(false)

    return (
        customType === "circleNumber" ?
            <input
                id={id}
                name={id}
                className={`form-control rounded-5 ops-inp-circle-num ops-inp ${className} ${error && "ops-inp-error"}`}
                type="text"
                disabled={disabled}
                placeholder={placeholder || "0"}
                value={value}
                onChange={onChange}
                maxLength={maxLength || 1}
            />
            : customType === "time" ?
                <div className="fa-flex-col">
                    {label.length > 0 && <label className={`mt-2 pb-1 ${labelColor} font-${labelWeight}`}
                                                htmlFor={`inp-${id}`}>{label}</label>}
                    <input
                        id={`inp-${id}`}
                        name={id}
                        className={`ops-inp ops-inp-time form-control rounded-3 ${className} ${error && "ops-inp-error"}`}
                        type="time"
                        disabled={disabled}
                        placeholder={placeholder}
                        value={value}
                        onChange={onChange}
                        maxLength={maxLength}
                    />
                </div>
                : customType === "checkBox" ?
                    <div
                        className={`fa-flex-row align-items-center gap-2 ${componentClassName}`}>
                        <input
                            id={`inp-chck-${id}`}
                            name={id}
                            className={`ops-inp ops-inp-check form-check-input ${className} ${error && "ops-inp-error"}`}
                            type="checkbox"
                            disabled={disabled}
                            checked={value}
                            onChange={onChange}
                        />
                        {label.length > 0 && <label className={`txt-normal ${labelColor} font-${labelWeight}`}
                                                    htmlFor={`inp-chck-${id}`}>{label}</label>}
                    </div>
                    : customType === "radio" ?
                        <div className={`fa-flex-row align-items-center gap-2 ${componentClassName}`}>
                            <input
                                id={`inp-chck-${id}`}
                                name={id}
                                className={`ops-inp ops-inp-check form-check-input ${className} ${error && "ops-inp-error"}`}
                                type="radio"
                                disabled={disabled}
                                checked={value}
                                onChange={onChange}
                            />
                            {label.length > 0 && <label className={`txt-normal ${labelColor} font-${labelWeight}`}
                                                        htmlFor={`inp-chck-${id}`}>{label}</label>}
                        </div>
                        : customType === "normal" ?
                            <div className={`fa-flex-col ${componentClassName}`}>
                                {label.length > 0 && <label className={`mt-2 pb-1 ${labelColor} font-${labelWeight}`}
                                                            htmlFor={`inp-${id}`}>{label}</label>}
                                <input
                                    id={`inp-${id}`}
                                    name={id}
                                    className={`ops-inp fa-w-100 ops-inp-${size} form-control rounded-3 ${className} ${error && "ops-inp-error"}`}
                                    type={type}
                                    accept={accept}
                                    autoFocus={autoFocus}
                                    disabled={disabled}
                                    placeholder={placeholder}
                                    value={value}
                                    onChange={onChange}
                                    maxLength={maxLength}
                                />
                            </div>
                            : customType === "password" ?
                                <div className={`fa-flex-col ${componentClassName}`}>
                                    {label.length > 0 && <label className={`mt-2 pb-1 ${labelColor} font-${labelWeight}`}
                                                                htmlFor={`inp-${id}`}>{label}</label>}
                                    <div style={{position: 'relative'}}>
                                        <input
                                            id={`inp-${id}`}
                                            name={id}
                                            className={`ops-inp ops-inp-${size} form-control rounded-3 ${className} ${error && "ops-inp-error"}`}
                                            type={showPassword ? 'text' : 'password'}
                                            disabled={disabled}
                                            placeholder={placeholder}
                                            value={value}
                                            onChange={onChange}
                                            maxLength={maxLength}
                                        />
                                        {value.length > 0 &&
                                            <span
                                                style={{
                                                    position: 'absolute',
                                                    top: size === 'bg' ? '30%' : '50%',
                                                    right: '15px',
                                                    transform: 'translateY(-50%)',
                                                    cursor: 'pointer'
                                                }}
                                                onClick={() => setShowPassword(!showPassword)}
                                            >
                                             {showPassword ?
                                                 <FaEyeSlash color="var(--color-g-1)" className="ops-icon-sm"/>
                                                 :
                                                 <FaEye color="var(--color-g-1)" className="ops-icon-sm"/>
                                             }
                                        </span>
                                        }
                                    </div>
                                </div>
                                : customType === "textarea" ?
                                    <div className={`fa-flex-col fa-w-100 ${componentClassName}`}>
                                        {label.length > 0 &&
                                            <label className={`mt-2 pb-1 ${labelColor} font-${labelWeight}`}
                                                   htmlFor={`inp-${id}`}>{label}</label>}
                                        <textarea id={`textarea-${id}`}
                                                  name={id}
                                                  className={`ops-inp form-control rounded-3 ${className} ${error && "ops-inp-error"}`}
                                                  placeholder={placeholder}
                                                  value={value}
                                                  disabled={disabled}
                                                  onChange={onChange}
                                                  maxLength={maxLength}
                                        />
                                    </div>
                                    : customType === "imgUpload" ?
                                        <div className={`fa-flex-col ${componentClassName}`}>
                                            {label.length > 0 &&
                                                <label className={`mt-2 pb-1 ${labelColor} font-${labelWeight}`}
                                                       htmlFor={`inp-${id}`}>{label}</label>}
                                            <input id={`textarea-${id}`}
                                                   name={id}
                                                   disabled={disabled}
                                                   accept="image/"
                                                   type="file"
                                                   className={`ops-inp form-control rounded-3 ${className} ${error && "ops-inp-error"}`}
                                                   onChange={onChange}/>
                                        </div>
                                        : customType === "select" ?
                                            <div className={`fa-flex-col ${componentClassName}`}>
                                                {label.length > 0 &&
                                                    <label className={`mt-2 pb-1 ${labelColor} font-${labelWeight}`}
                                                           htmlFor={`inp-${id}`}>{label}</label>}
                                                <Select
                                                    id={`sel-${id}`}
                                                    name={id}
                                                    isDisabled={disabled}
                                                    className={`ops-sel-${size} ${className} ${error && "ops-inp-error"}`}
                                                    isClearable={isClearable}
                                                    isSearchable={isSearchable}
                                                    options={options}
                                                    value={value ?? null}
                                                    defaultValue={value ?? null}
                                                    onChange={onChange}
                                                    theme={(theme) => ({
                                                        ...theme,
                                                        colors: {
                                                            ...theme.colors,
                                                            primary25: 'var(--color-p-100)',
                                                            primary: 'var(--color-p-300)',
                                                        },
                                                    })}
                                                />
                                            </div>
                                            : customType === "switch" ?
                                                <div className="fa-flex-row align-items-center gap-3">
                                                    {label.length > 0 &&
                                                        <label className={`mt-2 pb-1 ${labelColor} font-${labelWeight}`}
                                                               htmlFor={`inp-${id}`}>{label}</label>}
                                                    <Switch
                                                        id={`toggle-${id}`}
                                                        name={id}
                                                        disabled={disabled}
                                                        uncheckedIcon={uncheckedIcon}
                                                        checkedIcon={checkedIcon}
                                                        boxShadow={boxShadow}
                                                        activeBoxShadow={activeBoxShadow}
                                                        height={height}
                                                        width={width}
                                                        onChange={onChange}
                                                        className={` ${className}`}
                                                        checked={checked}
                                                        offColor={offColor}
                                                        onColor={onColor}
                                                    />
                                                </div>
                                                : customType === "themeSwitch" ?
                                                    <div className="fa-flex-row align-items-center gap-3">
                                                        {label.length > 0 &&
                                                            <label className={`mt-2 pb-1 ${labelColor} font-${labelWeight}`}
                                                                   htmlFor={`inp-${id}`}>{label}</label>}
                                                        <Switch
                                                            uncheckedIcon={<i className="i-sun"/>}
                                                            checkedIcon={<i className="i-moon"/>}
                                                            boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
                                                            activeBoxShadow="0px 0px 1px 10px rgba(0, 0, 0, 0.2)"
                                                            height={20}
                                                            width={40}
                                                            onChange={onChange}
                                                            className={` ${className}`}
                                                            checked={checked}
                                                            disabled={disabled}
                                                            offColor="#757575"
                                                            onColor="#25428c"
                                                            id="material-switch"
                                                        />
                                                    </div>

                                                    : <input/>

        // <div>
        //     <input
        //         className={`form-control rounded-3 ${className}`}
        //         type={type}
        //         id={id}
        //         placeholder={placeholder}
        //         value={value}
        //         onChange={onChange}
        //     />
        // </div>

        // <div className="pass-wrapper">
        //     {" "}
        //     <input
        //         className={`form-control rounded-3 ${className}`}
        //         type={passwordShown ? "text" : {type}}
        //         id={id}
        //         placeholder={placeholder}
        //         value={value}
        //         onChange={onChange}
        //         // ref={register({ required: "This is required." })}
        //     />
        //     <i onClick={togglePasswordVisiblity}>{eye}</i>{" "}
        // </div>

        // <div className="input-group">
        //     <input type="password" className="form-control rounded" required/>
        //     <button id="toggle-password" type="button" className="d-none"
        //             aria-label="Show password as plain text">
        //     </button>
        // </div>
    );
};

export default OpsInput;